import { DateOnly } from '@if/core/date'
import { t } from '@if/core/i18n'
import { dateOnly, InferType, mixed, number, object, string } from '@if/core/yup'
import { EFeeType, VALID_FEE_TYPES } from '@src/types/constants'
import { OperationInformation } from '@src/types/loan/loan-operation'

const getBalanceForFeeType = (
  operationInformations: OperationInformation[],
  effectiveDate: DateOnly,
  feeType: EFeeType,
): number => {
  const nearestOp = operationInformations.findLast(
    (oi) => oi.operation.effectiveDate && oi.operation.effectiveDate <= effectiveDate,
  )
  if (!nearestOp) return 0

  switch (feeType) {
    case EFeeType.NsfFees:
      return nearestOp.operationResultDto.nsfBalance
    case EFeeType.GeneralFees:
      return nearestOp.operationResultDto.otherBalance
    default:
      return 0
  }
}

export const getAddFeeSchema = (operationInformations: OperationInformation[]) =>
  object({
    feeType: mixed<EFeeType>().oneOf(VALID_FEE_TYPES).required(),
    amount: number().required().notOneOf([0]),
    effectiveDate: dateOnly()
      .required()
      .min(new DateOnly(), () => t('loan.feesDialog.errors.effectiveDateBeforeToday')),
    note: string().notRequired().default(''),
  }).test('fee-balance-not-negative', '', function (values) {
    const { amount, feeType, effectiveDate } = values
    if (!amount || amount >= 0 || !feeType || !effectiveDate) return true
    const balance = getBalanceForFeeType(operationInformations, effectiveDate, feeType as EFeeType)
    if (amount + balance >= 0) return true
    return this.createError({
      path: 'amount',
      message: t('loan.feesDialog.errors.feeBalanceNegative'),
    })
  })

export type AddFeeSchemaType = InferType<ReturnType<typeof getAddFeeSchema>>
